<template>
    <header class="header d-flex justify-content-between align-items-center invert">
        <div class="container-fluid d-flex justify-content-between align-items-center">
            <kinesis-element :strength="7">
            <router-link to="/" class="brand">
                <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 240 257" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h239.004v256.429h-239.004z" fill="none"/><path d="m73.248 220.021v-113.507l58.245-58.244h19.745c9.047 0 17.514 2.532 24.73 6.924l-82.776 82.775 5.592 5.706h-.224l25.517 25.517zm-60.335-53.171 52.763-52.764v105.527zm60.335-118.58h47.537l-47.537 47.537zm119.694.658 7.167-7.167 25.699 25.7-6.157 6.157-33.811 33.811-33.338 33.338-2.908 2.908h-15.865-24.342l-5.54-5.652 56.293-56.293zm-28.926 92.995c-.862.24-1.732.458-2.612.65l1.807-1.806 34.628-34.628c-3.766 17.275-16.915 31.076-33.823 35.784m-34.585 21.915-12.591-12.591h25.182l-2.271 2.271zm21.028-10.32 2.311-2.31c3.86-.106 7.621-.607 11.246-1.469 23.856-5.67 41.761-26.835 42.457-52.235l30.043-30.043-36.407-36.408-18.664 18.664c-8.69-5.694-19.065-9.019-30.207-9.019h-12.173l35.344-35.344-5.354-5.354-40.698 40.698h-62.681v62.68l-63.472 63.472 63.472 63.471v22.767h7.572v-22.359l56.183-56.183 78.585 78.584 10.78.073-84.011-84.011z" fill="#fff" fill-rule="nonzero"/></svg>
            </router-link>
            </kinesis-element>
            <kinesis-element :strength="7">
            <div class="d-flex">
                <button v-bind:class='{active:isActive}' v-on:click='isActive=!isActive' class="navbar-toggler animated lightSpeedIn" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown">
                    <span class="bar top-bar"></span>
                    <span class="bar middle-bar"></span>
                    <span class="bar bottom-bar"></span>
                </button>
            </div>
            </kinesis-element>
        </div>
        <div class="navbar-dropdown">
            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                <ul>
                    <li><router-link to="/">Home</router-link></li>
                    <li><router-link to="/contact">Contact</router-link></li>
                </ul>
            </div>
        </div>
    </header>
</template>

<script>
    /* eslint-disable */
    export default {
        data () {
            return {
                isActive: false
            }
        }
    }
</script>
